import { render, staticRenderFns } from "./studyHeader.vue?vue&type=template&id=4b579dd8&scoped=true"
import script from "./studyHeader.vue?vue&type=script&lang=js"
export * from "./studyHeader.vue?vue&type=script&lang=js"
import style0 from "./studyHeader.vue?vue&type=style&index=0&id=4b579dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b579dd8",
  null
  
)

export default component.exports